import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import React from 'react';
import { type SerializedStyles } from '@emotion/react';
import { Text, Icon } from '@pairy/pds-react';

import * as Styled from './index.styles';

interface Props<T> {
  items: readonly { label: string; value: T }[];
  onValueChanges: (value: T) => void;
  initialValue?: T;
  align?: DropdownMenu.DropdownMenuContentProps['align'];
  sideOffset?: DropdownMenu.DropdownMenuContentProps['sideOffset'];
  buttonCss?: SerializedStyles;
}

const SortTypeDropdown = <T extends string>({
  items,
  onValueChanges,
  initialValue,
  align = 'center',
  sideOffset = 0,
  buttonCss,
}: Props<T>) => {
  const [value, setValue] = React.useState<string>(
    items[items.findIndex((item) => item.value === initialValue)]?.label ??
      items[0].label,
  );

  const handleChangeValue = (value: string) => {
    const index = items.findIndex((item) => item.value === value);

    setValue(items[index].label);

    onValueChanges(value as T);
  };

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <Styled.TriggerButton css={buttonCss}>
          <Text variant="md-medium" color="zinc_400">
            {value}
          </Text>
          <Icon icon="ph:caret-down" size={17} color="zinc_400" />
        </Styled.TriggerButton>
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <Styled.DropdownMenuContent align={align} sideOffset={sideOffset}>
          <DropdownMenu.RadioGroup
            value={value}
            onValueChange={handleChangeValue}
          >
            {items.map((item) => (
              <Styled.DropdownMenuRadioItem
                key={item.value}
                value={item.value}
                className={item.label === value ? 'active' : ''}
              >
                <Text variant="md-medium" color="zinc_400">
                  {item.label}
                </Text>
              </Styled.DropdownMenuRadioItem>
            ))}
          </DropdownMenu.RadioGroup>
        </Styled.DropdownMenuContent>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};

export default SortTypeDropdown;
